import { List, ListItem, Typography } from '@mui/material';
import { useAppNavigation } from 'react-components/app/routing/routes';
import { messageTemplatesSelectors } from 'redux/slices/messageTemplatesSlice';
import { LeftDrawer } from '../LeftDrawer';
import { useState } from 'react';

interface Props {
  children: React.ReactNode;
}

export const MessageContent = ({ children }: Props) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const navigate = useAppNavigation();
  const messageTemplates = Object.values(
    messageTemplatesSelectors.useSelectAll().entities
  );

  const drawerContent = (
    <List sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mt: 2 }}>
      <ListItem
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
          wordWrap: 'none',
          backgroundColor:
            selectedId === null ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
        onClick={() => navigate.toAllMessageCategories()}
      >
        <Typography sx={{ fontSize: '20px' }}>All Categories</Typography>
      </ListItem>
      {messageTemplates
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((category, index) => (
          <ListItem
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              wordWrap: 'none',
              backgroundColor:
                selectedId === category.id
                  ? 'rgba(0, 0, 0, 0.04)'
                  : 'transparent',
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
            onClick={() => {
              setSelectedId(category.id);
              navigate.toMessageCategory(category.id);
            }}
          >
            <Typography>{category?.name || `Category ${index + 1}`}</Typography>
          </ListItem>
        ))}
    </List>
  );
  return <LeftDrawer drawerContent={drawerContent}>{children}</LeftDrawer>;
};
